import { Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import calculateBaseOdds from '../../utils/pity-odds-calculator';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { PriceProviderService } from 'src/app/services/price-provider.service';

Chart.register(...registerables);

@Component({
  selector: 'gear-root',
  templateUrl: './gear.component.html',
  styleUrls: ['../../shared-scss/default.scss'],
  standalone: false,
})
export class GearComponent implements OnInit {
  constructor(
    private readonly gaService: GoogleAnalyticsService,
    readonly priceProvider: PriceProviderService
  ) {}

  ngOnInit(): void {
    this.SimulateUpgrading(false);
  }

  title = 'flyff-upgrade-calculator';

  simulationCount = 10000;

  sProsUsed: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  sProLowsUsed: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  mineralsUsed: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  eronsUsed: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  pd4Used: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  pd6Used: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  customUpgradeBonus = 0;
  getModifier() {
    let bonus = this.customUpgradeBonus;
    if (this.priceProvider.isFwc) {
      bonus += 100;
    }
    return 1 + bonus / 100;
  }
  isPd12 = false;
  isUpgradeEvent = false;
  currentAttemptsIn = 0;
  currentUpgrade = 0;
  targetUpgrade = 10;
  useLowsUntil = 7;

  materialCostPerLevel = [10, 14, 20, 27, 38, 54, 75, 105, 148, 207];

  baseOdds = [90, 85, 80, 54, 40.5, 27, 18, 9, 4.5, 1.8];
  baseUpgradeEventOdds = [95, 90, 84, 57, 42.5, 29, 20, 10, 5, 2];
  basePd12Odds = [100, 100, 88, 60, 44.5, 30, 21.5, 11, 5.4, 2.09];
  baseUpgradeEventPd12Odds = [100, 100, 92.5, 63, 46.5, 32, 24, 12, 6, 2.3];

  odds = this.baseOdds.map((x) => x * this.getModifier());
  upgradeEventOdds = this.baseUpgradeEventOdds.map((x) => x * this.getModifier());
  pd12Odds = this.basePd12Odds.map((x) => x * this.getModifier());
  upgradeEventPd12Odds = this.baseUpgradeEventPd12Odds.map((x) => x * this.getModifier());

  pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEvent = this.baseUpgradeEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsPd12 = this.basePd12Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEventPd12 = this.baseUpgradeEventPd12Odds.map((x) =>
    calculateBaseOdds(x * this.getModifier())
  );

  myChart: Chart | undefined = undefined;

  GenerateChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }

    const chartData: any = {
      labels: ['+0 > +1', '+1 > +2', '+2 > +3', '+3 > +4', '+4 > +5', '+5 > +6', '+6 > +7', '+7 > +8', '+8 > +9', '+9 > +10'],
      datasets: [
        {
          label: "sPro's",
          data: this.sProsUsed.map((x) => x / this.simulationCount),
          borderWidth: 1,
        },
        {
          label: "sPro Low's",
          data: this.sProLowsUsed.map((x) => x / this.simulationCount),
          borderWidth: 1,
        },
      ],
    };

    const config: any = {
      type: 'bar',
      data: chartData,
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    };

    const chartElem = <HTMLCanvasElement>(
      document.getElementById(`upgrade-data-chart`)
    );

    this.myChart = new Chart(chartElem, config);
  }

  SimulateUpgrading(isUserInput = true) {
    if (!this.verifyInput()) {
      return;
    }
    if (isUserInput) {
      this.gaService.event(
        'simulate_gear_upgrade',
        'simulate',
        'Simulate gear upgrade',
        this.simulationCount,
        true
      );
    }

    // Reset starter values
    this.sProsUsed = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.sProLowsUsed = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.mineralsUsed = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.eronsUsed = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.pd4Used = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.pd6Used = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // Calculate modified odds with upgrade bonus
    this.odds = this.baseOdds.map((x) => x * this.getModifier());
    this.upgradeEventOdds = this.baseUpgradeEventOdds.map((x) => x * this.getModifier());
    this.pd12Odds = this.basePd12Odds.map((x) => x * this.getModifier());
    this.upgradeEventPd12Odds = this.baseUpgradeEventPd12Odds.map((x) => x * this.getModifier());

    this.pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEvent = this.baseUpgradeEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsPd12 = this.basePd12Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEventPd12 = this.baseUpgradeEventPd12Odds.map((x) =>
      calculateBaseOdds(x * this.getModifier())
    );

    // Start upgrading
    for (let i = 0; i < this.simulationCount; i++) {
      let currentUpgrade = this.currentUpgrade;
      //Continue upgrading until target upgrade is reached
      while (currentUpgrade < this.targetUpgrade) {
        // If we are still in the low upgrade range, use low upgrades
        if (currentUpgrade < this.useLowsUntil) {
          const isSuccessful = this.SimulateSingleLowUpgrade(currentUpgrade);
          if (isSuccessful) {
            currentUpgrade++;
          } else {
            currentUpgrade = Math.max(currentUpgrade - 1, 0);
          }
        } else {
          // If we are in the high upgrade range, use normal upgrades
          let failedTries = 0;
          if (currentUpgrade === this.currentUpgrade) {
            failedTries = this.currentAttemptsIn;
          }
          let isSuccessful = false;
          while (!isSuccessful) {
            isSuccessful = this.SimulateSingleUpgrade(
              currentUpgrade,
              failedTries
            );
            if (!isSuccessful) {
              failedTries++;
            }
          }
          currentUpgrade++;
        }
      }
    }

    this.GenerateChart();
  }

  verifyInput() {
    // clear all red inputs
    let isValid = true;
    if (this.currentUpgrade < 0 || this.currentUpgrade > 9) {
      // make input red
      isValid = false;
    }
    if (this.targetUpgrade < 1 || this.targetUpgrade > 10) {
      // make input red
      isValid = false;
    }
    if (this.currentUpgrade >= this.targetUpgrade) {
      // make input red
      isValid = false;
    }
    if (this.useLowsUntil < 0 || this.useLowsUntil > 10) {
      // make input red
      isValid = false;
    }
    if (this.currentAttemptsIn < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.sProPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.sProLowPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.eronPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.mineralPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.pd4Price < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.pd6Price < 0) {
      // make input red
      isValid = false;
    }
    return isValid;
  }

  addUpgradeTry(currentUpgrade: number) {
    this.mineralsUsed[currentUpgrade] +=
      this.materialCostPerLevel[currentUpgrade];
    this.eronsUsed[currentUpgrade] += this.materialCostPerLevel[currentUpgrade];
    if (currentUpgrade < this.useLowsUntil) {
      this.sProLowsUsed[currentUpgrade]++;
    } else {
      this.sProsUsed[currentUpgrade]++;
    }
    if (currentUpgrade < 5) {
      this.pd4Used[currentUpgrade]++;
    } else {
      this.pd6Used[currentUpgrade]++;
    }
  }

  SimulateSingleLowUpgrade(currentUpgrade: number): boolean {
    this.addUpgradeTry(currentUpgrade);
    const random = Math.random() * 100;
    const odds = this.GetUpgradeOdds()[currentUpgrade];

    if (random < odds) {
      return true;
    }
    return false;
  }

  SimulateSingleUpgrade(currentUpgrade: number, failedTries: number): boolean {
    this.addUpgradeTry(currentUpgrade);
    const random = Math.random() * 100;
    let initialOdds = this.GetUpgradeOdds(true)[currentUpgrade];

    let odds = initialOdds * (failedTries + 1);
    if (random < odds) {
      return true;
    }
    return false;
  }

  GetSprosUsed(): number {
    return this.sProsUsed.reduce((a, b) => a + b, 0);
  }

  GetSproLowsUsed(): number {
    return this.sProLowsUsed.reduce((a, b) => a + b, 0);
  }

  GetEronsUsed(): number {
    return this.eronsUsed.reduce((a, b) => a + b, 0);
  }

  GetMineralsUsed(): number {
    return this.mineralsUsed.reduce((a, b) => a + b, 0);
  }

  GetPd4sUsed(): number {
    return this.pd4Used.reduce((a, b) => a + b, 0);
  }

  GetPd6sUsed(): number {
    return this.pd6Used.reduce((a, b) => a + b, 0);
  }

  GetTotalPenyaCost(): number {
    const totalSproCost =
      this.GetSprosUsed() * this.priceProvider.sProPrice +
      this.GetSproLowsUsed() * this.priceProvider.sProLowPrice;
    const totalMaterialCost =
      this.GetEronsUsed() * this.priceProvider.eronPrice +
      this.GetMineralsUsed() * this.priceProvider.mineralPrice;
    const totalDiceCost =
      this.GetPd4sUsed() * this.priceProvider.pd4Price + this.GetPd6sUsed() * this.priceProvider.pd6Price;
    return totalSproCost + totalMaterialCost + totalDiceCost;
  }

  GetUpgradeOdds(isPity: boolean = false): number[] {
    type OddsKey = 'default' | 'upgradeEvent' | 'pd12' | 'upgradeEventPd12';

    const baseOdds: Record<OddsKey, number[]> = {
      default: this.odds,
      upgradeEvent: this.upgradeEventOdds,
      pd12: this.pd12Odds,
      upgradeEventPd12: this.upgradeEventPd12Odds,
    };

    const pityOdds: Record<OddsKey, number[]> = {
      default: this.pityOdds,
      upgradeEvent: this.pityOddsEvent,
      pd12: this.pityOddsPd12,
      upgradeEventPd12: this.pityOddsEventPd12,
    };

    let key: OddsKey = 'default';
    if (this.isPd12 && this.isUpgradeEvent) key = 'upgradeEventPd12';
    else if (this.isUpgradeEvent) key = 'upgradeEvent';
    else if (this.isPd12) key = 'pd12';

    let odds;
    if (isPity) {
      odds = pityOdds[key];
    } else {
      odds = baseOdds[key];
    }
    return odds;
  }
}
